// The address the MPass AssertionConsumerService redirects to once it has set
// the session cookie (`apps/bff/src/auth/auth.controller.ts` callback, which has
// sent readers to `${UI_URL}/login-success` since UC10 shipped). No route ever
// answered it, so a successful MPass login landed on the not-found placeholder
// — the mirror image of UC10-06's missing screen on the same path, and the
// reason the "sign in again" action on AuthNoticePage would otherwise be a dead
// end of its own.
//
// It holds no copy: it reads the session the ACS just minted and forwards to the
// role picker or to that role's home, exactly as the development login does.
//
// It is also where an MPass authentication ends. The new session holds no
// active Registrar, so a person with several selects one after authentication
// (caiet NC-UC50-01); what this browser knew of an earlier sign-in is forgotten
// here as a new start (docs/shape-ops-tenant-selector.md §9.2).
import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslate } from '@tolgee/react';
import { clearActiveRegistrar } from '../app/active-registrar';
import { landingPathFor } from '../app/role-home';
import { useSession } from '../hooks/use-session';

export function LoginSuccessPage(): JSX.Element {
  const { t } = useTranslate();
  const sessionQuery = useSession();
  useEffect(() => {
    clearActiveRegistrar();
  }, []);

  if (sessionQuery.isPending) {
    return (
      <main className="simsm-auth-notice__pending">
        <p>{t('common.loading')}</p>
      </main>
    );
  }

  const session = sessionQuery.data;
  if (!session) {
    // The cookie is gone or was refused between the ACS and here. That is the
    // expired-session state, not a role problem, so it gets that screen.
    return <Navigate to="/auth/session-expired" replace />;
  }
  return <Navigate to={landingPathFor(session.activeRole, session.availableRoles)} replace />;
}
